export default {
    path: "/testing",
    name: "testing",
    meta: {
        icon: "ios-flask",
        access: "menu_testing",
        title: "测试用例",
    },
    component: () => import("@/views/Main.vue"),
    children: [
        {
            path: "testhome",
            name: "testhome",
            meta: {
                icon: "ios-flask",
                access: "menu_testing_control",
                title: "测试单",
            },
            component: () => import("@/views/testing/list.vue"),
        },
        {
            path: "testplan",
            name: "testplan",
            meta: {
                icon: "md-people",
                access: "menu_testing_planed",
                title: "测试计划",
            },
            component: () => import("@/views/testing/testplan.vue"),
        },

        // {
        //     path: 'procount',
        //     meta: {
        //         icon: 'md-calendar',
        //         access: 'menu_testing_fun',
        //         title: '功能'
        //     },
        //     component: () =>
        //         import ('@/views/parent-view.vue'),
        //     children: [{
        //             path: 'example',
        //             name: 'example',
        //             meta: {
        //                 icon: 'md-people',
        //                 access: 'menu_testing_cases',
        //                 title: '用例管理'
        //             },
        //             component: () =>
        //                 import ('@/views/testing/example.vue')
        //         },
        //         {
        //             path: 'testplan',
        //             name: 'testplan',
        //             meta: {
        //                 icon: 'md-people',
        //                 access: 'menu_testing_planed',
        //                 title: '测试计划'
        //             },
        //             component: () =>
        //                 import ('@/views/testing/testplan.vue')
        //         },
        //         {
        //             path: 'version',
        //             name: 'version',
        //             meta: {
        //                 icon: 'ios-appstore',
        //                 access: 'menu_testing_vertion',
        //                 title: '版本库管理'
        //             },
        //             component: () =>
        //                 import ('@/views/testing/version.vue')
        //         },
        //         {
        //             path: 'pushdeploy',
        //             name: 'pushdeploy',
        //             meta: {
        //                 icon: 'ios-appstore',
        //                 access: 'menu_testing_release',
        //                 title: '发布管理'
        //             },
        //             component: () =>
        //                 import ('@/views/deploy/application.vue')
        //         },
        //     ]
        // }
    ],
};
